/**
 * @generated SignedSource<<36539ff6c9328d06237b2c2ab9935977>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_enabledDataFragment$data = {
  readonly options: {
    readonly isEmailNotificationEnabled: boolean | null | undefined;
  };
  readonly " $fragmentType": "notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_enabledDataFragment";
};
export type notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_enabledDataFragment$key = {
  readonly " $data"?: notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_enabledDataFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_enabledDataFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_enabledDataFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraNotificationOptions",
        "kind": "LinkedField",
        "name": "options",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isEmailNotificationEnabled"
          }
        ]
      },
      "action": "THROW",
      "path": "options"
    }
  ],
  "type": "JiraNotificationGlobalPreference"
};

(node as any).hash = "2f9c5245399476edc2437dfaad9bc9f0";

export default node;
